import { RootState } from '../types/rootstate'

export const formSelector = (state: RootState, formId) => {
  return state.forms[formId]
}

export const formVersionIdSelector = (state: RootState, formId) => {
  return state.forms[formId]?.versionId
}
